import { BaseEntityAdapter } from "@brains/plugins";
import {
  newsletterSchema,
  newsletterFrontmatterSchema,
  type Newsletter,
  type NewsletterMetadata,
} from "../schemas/newsletter";

/**
 * Adapter for newsletter entities
 * Stores metadata in frontmatter, content body contains newsletter HTML/markdown
 */
export class NewsletterAdapter extends BaseEntityAdapter<
  Newsletter,
  NewsletterMetadata,
  NewsletterMetadata
> {
  constructor() {
    super({
      entityType: "newsletter",
      purpose: "An email newsletter issue composed for subscribers.",
      schema: newsletterSchema,
      frontmatterSchema: newsletterFrontmatterSchema,
    });
  }

  public override toMarkdown(entity: Newsletter): string {
    const body = this.extractBody(entity.content);
    return this.buildMarkdown(body, entity.metadata);
  }

  public fromMarkdown(markdown: string): Partial<Newsletter> {
    const metadata = this.parseFrontmatter(markdown);
    return {
      entityType: "newsletter",
      content: markdown,
      metadata,
    };
  }

  public buildStub(input: { id: string; title: string }): {
    content: string;
    metadata: NewsletterMetadata;
  } {
    const metadata: NewsletterMetadata = {
      subject: input.title,
      status: "generating",
    };
    return {
      content: this.buildMarkdown("", metadata),
      metadata,
    };
  }
}

export const newsletterAdapter: NewsletterAdapter = new NewsletterAdapter();
